import {array, number, object, string} from 'yup';

import {localizedTextRequired, stringOptionalNullable} from '@shared/utils';

export const adminBannerListV8nSchema = object().shape({
  id: string().required(),
  name: string().defined(),
  logo_url: string().required(),
  app_url: stringOptionalNullable,
  web_url: stringOptionalNullable,
  active_from: string().nullable().optional(),
  active_to: string().nullable().optional(),
  geos: array().of(string().required()).defined(),
  order: number().optional(),
});

export const adminBannerDetailV8nSchema = object().shape({
  id: string().required(),
  name: localizedTextRequired,
  logo_url: string().required(),
  app_url: stringOptionalNullable,
  web_url: stringOptionalNullable,
  active_from: string().nullable().optional(),
  active_to: string().nullable().optional(),
  geos: array().of(string().required()).defined(),
  order: number().optional(),
});

export const v8nSchemaOfGetAdminBannersResponse = array().of(
  adminBannerListV8nSchema,
);
